<template>
  <div>
    <div class="side-content-wrap">
      <div class="sidebar-left rtl-ps-none ps ps--active-y open" data-perfect-scrollbar data-suppress-scroll-x="true">
        <ul class="navigation-left">
          <li class="nav-item" v-for="list in roledLists" v-bind:key="list.id" :data-item="list.item"
            @mouseover="list.hover = true" @mouseleave="list.hover = false" :class="{ active: list.hover }">
            <!-- Grid and link -->
            <router-link :to="list.link">
              <a class="nav-item-hold">
                <!-- Icon -->
                <i :class="list.icon" v-if="list.icon"></i>
                <div v-else>
                  <img :src="list.image" :width="list.width" />
                  <span class="nav-text">
                    <span>{{ list.title }}</span>
                  </span>
                </div>
                <!-- Text -->
                <span class="nav-text">
                  <span v-if="list.icon">{{ list.title }}</span>
                  <span class="badge badge-pill badge-danger" v-if="list.badge !== 0">{{ list.badge }}</span>
                  <span class="badge badge-pill badge-success" v-if="list.notification_badge !== 0">{{
                    list.notification_badge }}</span>
                </span>
              </a>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="sidebar-left-secondary" data-perfect-scrollbar data-suppress-scroll-x="true">
        <!-- Submenu Dashboards -->
        <ul v-for="(lists, index) in filteredSideLists" v-bind:key="index" class="childNav" :data-parent="lists.parent">
          <li v-for="(list, index) in lists.children" v-bind:key="index" class="nav-item">
            <router-link :to="list.link">
              <i class="nav-icon"></i>
              <span class="item-name">{{ list.title }}</span>
              <span class="badge badge-pill badge-danger" v-if="list.badge !== 0" style="margin-left: 2px">{{ list.badge
              }}</span>
            </router-link>
          </li>
        </ul>
      </div>

      <div class="sidebar-overlay"></div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
const user = JSON.parse(localStorage.getItem("user"));
export default {
  name: "SideNavComponent",

  data() {
    return {
      listHover: false,
      tbaNew: [],
      tbaNew_claim: [],
      tbkNew_claim: [],
      tbaPending_call: "",
      tbkPending_call: "",
      notification: [],
      roles: user.roles,
      tbaNew_chat: [],
      tbkNew_chat: [],

      user: JSON.parse(localStorage.getItem("user")),

      // Side Nav Items
      lists: [
        {
          title: "Dashboard",
          icon: "nav-icon fas fa-tachometer-alt",
          link: "/dashboard",
          hover: false,
          roles: [
            "Administrator",
            "Call Centre",
            "Charity",
            "Claim",
            "Finance",
            "General",
            "TBA Staff",
            "TBK Staff",
            "Marketing"
          ],
          except: []
        },

        {
          title: "Notifications",
          icon: "nav-icon fas fa-bell",
          link: "/notifications",
          hover: false,
          badge: 0,
          roles: ["All"],
          except: ["Marketing", "Administrator", "Finance"]
        },

        {
          title: "TBA",
          item: "tba",
          icon: false,
          image: require("@/assets/icons/TBA_Logo.png"),
          link: "/tba_claim",
          hover: false,
          badge: 0,
          notification_badge: 0,
          roles: ["TBA Staff", "Administrator"],
          except: [],
          lps: true
        },

        {
          title: "TBK",
          item: "tbk",
          icon: false,
          image: require("@/assets/icons/TBK_Logo.png"),
          link: "/tbk_claim",
          hover: false,
          badge: 0,
          notification_badge: 0,
          roles: ["TBK Staff", "Administrator"],
          lps: true
        },

        // {
        //   title: "Live Chat",
        //   icon: "nav-icon fas fa-comments",
        //   link: "/live-chat",
        //   hover: false,
        //   badge: 2,
        // },

        {
          title: "Customers",
          icon: "nav-icon fas fa-address-card",
          link: "/customers",
          hover: false,
          roles: [
            "Administrator",
            "Call Centre",
            "Charity",
            "Claim",
            "Finance",
            "General",
            "TBA Staff",
            "TBK Staff",
            "Marketing"
          ],
          except: []
        },

        // {
        //   title: "Customer Points",
        //   icon: "nav-icon fas fa-address-card",
        //   link: "/user-balance",
        //   hover: false,
        //   roles: [
        //     "Administrator",
        //     "Call Centre",
        //     "Charity",
        //     "Claim",
        //     "Finance",
        //     "General",
        //     "TBA Staff",
        //     "TBK Staff",
        //     "Marketing"
        //   ],
        //   except: []
        // },

        {
          title: "OTPS",
          icon: "nav-icon fas fa-key",
          link: "/otps",
          hover: false,
          roles: [
            "Administrator",
            "Call Centre",
            "Charity",
            "Claim",
            "Finance",
            "General",
            "TBA Staff",
            "TBK Staff"
          ],
          except: []
        },

        {
          title: "TBA Call Request",
          icon: "nav-icon fas fa-phone",
          link: "/tba_call_request",
          hover: false,
          badge: 0,
          roles: ["TBA Staff", "Administrator"],
          except: []
        },

        {
          title: "TBK Call Request",
          icon: "nav-icon fas fa-phone",
          link: "/tbk_call_request",
          hover: false,
          badge: 0,
          roles: ["TBK Staff", "Administrator"],
          except: []
        },

        {
          title: "TBA Apps Report",

          icon: "nav-icon fas fa-file-invoice-dollar",
          link: "/report-transactions-tba/1",
          // link: "/report-transactions",
          hover: false,
          roles: ["TBA Staff", "Finance", "Administrator"],
          except: []
        },

        {
          title: "TBK Apps Report",

          icon: "nav-icon fas fa-file-invoice-dollar",
          link: "/report-transactions-tbk/2",
          // link: "/report-transactions",
          hover: false,
          roles: ["TBK Staff", "Finance", "Administrator"],
          except: []
        },

        {
          title: "TBA Error",
          icon: "nav-icon fas fa-exclamation-triangle",
          link: "/tba-error",
          hover: false,
          roles: ["Call Centre", "Administrator"],
          except: []
        },

        {
          title: "TBK Error",
          icon: "nav-icon fas fa-exclamation-triangle",
          link: "/tbk-error",
          hover: false,
          roles: ["Call Centre", "Administrator"],
          except: []
        },

        {
          title: "Demographic",
          icon: "nav-icon fas fa-chart-line",
          link: "/demographic",
          hover: false,
          roles: ["TBA Staff", "TBK Staff", "Administrator"],
          except: []
        },

        {
          title: "Marketing",
          item: "marketing",
          icon: "nav-icon fas fa-user-friends",
          link: "/marketing",
          hover: false,
          lps: true,
          roles: ["Marketing", "Administrator"]
        },

        {
          title: "Loyalty Point System",
          item: "lps-main",
          icon: "nav-icon fas fa-tachometer-alt",
          link: "/lps/dashboard",
          hover: false,
          roles: ["Marketing"],
          except: [],
          lps: true
        },

        {
          title: "Threshold",
          item: "threshold",
          icon: "nav-icon fas fa-address-card",
          link: "/treshold",
          hover: false,
          roles: ["TBA Staff", "Administrator"],
          except: []
        },

        // {
        //   title: "Cash Winner",
        //   icon: false,
        //   image: require("@/assets/icons/cash-winner-icon.png"),
        //   width: "40%",
        //   link: "/cash-winner",
        //   hover: false,
        //   roles: ["Administrator", "Marketing", "Finance"],
        //   except: [],
        // },

        {
          title: "Change Form",
          icon: "nav-icon far fa-file-alt",
          link: "/change-forms",
          hover: false,
          roles: [
            "Administrator",
            "Call Centre",
            "Charity",
            "Claim",
            "Finance",
            "General",
            "TBA Staff",
            "TBK Staff"
          ],
          except: []
        },

        // {
        //   title: "Reports",
        //   item: "report",
        //   icon: "nav-icon fas fa-chart-line",
        //   link: "/report-claims",
        //   // link: "/finance_report",
        //   hover: false,
        //   roles: ['TBA Staff', 'TBK Staff', 'Administrator'],
        //   except: []
        // },

        // {
        //   title: "Vendor Account",
        //   icon: false,
        //   image: require("@/assets/icons/vendor-dashboard-vendor-account.png"),
        //   width: "30%",
        //   link: "/account/vendor",
        //   hover: false,
        //   roles: ["Marketing"],
        //   except: [],
        // },

        // {
        //   title: "Vendor Request",
        //   icon: false,
        //   image: require("@/assets/icons/vendor-dashboard-vendor.png"),
        //   width: "30%",
        //   link: "/vendor/view",
        //   hover: false,
        //   roles: ["Marketing"],
        //   except: [],
        // },

        // {
        //   title: "Charity",
        //   icon: false,
        //   image: require("@/assets/icons/vendor-dashboard-charity-dashboard-icon.png"),
        //   width: "30%",
        //   link: "/charity",
        //   hover: false,
        //   roles: ["Marketing"],
        //   except: [],
        // },

        // {
        //   title: "Affiliate",
        //   icon: false,
        //   image: require("@/assets/icons/TBM-Dashboard-Affiliate-Icon.png"),
        //   width: "30%",
        //   link: "/affiliate",
        //   hover: false,
        //   roles: ["Marketing"],
        //   except: [],
        // },

        // {
        //   title: "Survey",
        //   icon: false,
        //   image: require("@/assets/icons/survey.png"),
        //   width: "35%",
        //   link: "/survey",
        //   hover: false,
        //   roles: ["Marketing"],
        //   except: [],
        // },

        // {
        //   title: "Report",
        //   item: "report",
        //   icon: false,
        //   image: require("@/assets/icons/report-icon.png"),
        //   width: "20%",
        //   link: "/report/view/vendor",
        //   hover: false,
        //   roles: ["Marketing"],
        //   except: [],
        // },

        // {
        //   title: "Summary Report",
        //   icon: false,
        //   image: require("@/assets/icons/report-icon.png"),
        //   width: "20%",
        //   link: "/report-summary",
        //   hover: false,
        //   roles: ["Marketing"],
        //   except: [],
        // },

        // {
        //   title: "Voucher",
        //   icon: false,
        //   image: require("@/assets/icons/report-icon.png"),
        //   width: "20%",
        //   link: "/voucher/product",
        //   hover: false,
        //   roles: ["Administrator", "Marketing"],
        //   except: [],
        // },

        /**
         * ROLE - VENDOR
         */
        // Company Details
        {
          title: "Profile",
          icon: false,
          image: require("@/assets/vendor/banner.png"),
          width: "50%",
          link: "/banner",
          hover: false,
          roles: ["Vendor"],
          except: []
        },

        // Redeem
        {
          title: "Redeem",
          item: "redeem",
          icon: false,
          image: require("@/assets/vendor/redeem.png"),
          width: "50%",
          link: "/redeem",
          hover: false,
          roles: ["Vendor"],
          except: []
        },

        // Transactions
        // {
        //   title: "Transactions",
        //   icon: false,
        //   image: require("@/assets/vendor/handshake.png"),
        //   width: "50%",
        //   link: "/transaction",
        //   hover: false,
        //   roles: ["Vendor"],
        //   except: []
        // },

        // Product and Services
        {
          title: "Products & Services",
          icon: false,
          image: require("@/assets/vendor/product icon.png"),
          width: "30%",
          link: "/products-services",
          hover: false,
          roles: ["Vendor"],
          except: []
        },

        //Gifts
        {
          title: "Gift",
          icon: false,
          image: require("@/assets/vendor/product icon.png"),
          width: "30%",
          link: "/gift",
          hover: false,
          roles: ["Vendor"],
          except: []
        },

        // Payout
        {
          title: "Payout Report",
          icon: false,
          image: require("@/assets/vendor/report icon.png"),
          width: "30%",
          link: "/payout",
          hover: false,
          roles: ["Vendor"],
          except: []
        },

        {
          title: "My Account",
          icon: "nav-icon fas fa-user-cog",
          link: "/account",
          hover: false,
          roles: ["All"],
          except: []
        },

        {
          title: "Admin",
          item: "admin",
          icon: "nav-icon fas fa-user-shield",
          link: "/manage-users",
          hover: false,
          roles: ["Administrator"],
          except: []
        },

        // {
        //   title: "Setting",
        //   item: "setting",
        //   icon: false,
        //   image: require("@/assets/icons/setting.png"),
        //   width: "30%",
        //   link: "",
        //   hover: false,
        //   roles: ["Administrator", "Marketing"],
        //   except: [],
        // },

        {
          title: "Deleted Accounts",
          icon: "nav-icon fas fa-user-cog",
          link: "/deleted-account",
          hover: false,
          roles: ["Administrator", "Marketing"],
          except: []
        }
      ],

      sideLists: [
        {
          parent: "tba",
          children: [
            {
              title: "TBA Claim",
              link: "/tba_claim",
              badge: 0
            },
            {
              title: "Motor Participations",
              link: "/motor_purchases",
              badge: 0
            },

            {
              title: "SPD Entry Log",
              link: "/tba/spd_records"
            },
            {
              title: "SPD Entry History",
              link: "/tba/spd_records_history"
            },
            {
              title: "Content Listing",
              link: "/tba/content-listings"
            },
            {
              title: "Feedbacks",
              link: "/tba/feedback",
            },
            {
              title: "Approved Claims",
              link: "/tba/approved-claims"
            },
            {
              title: "Terms and Conditions",
              link: "/tba/terms-and-conditions"
            },
            {
              title: "Contact",
              link: "/tba/contacts"
            },
            // {
            //   title: "Live Chat",
            //   link: "/live-chat/1",
            //   badge: 0,
            // },
            // {
            //   title: "TBA Renewal",
            //   link: "/tba_renewal"
            // },
            // {
            //   title: "TBA Claim Report",
            //   link: "/report-claims",
            //   badge: 0
            // }
          ]
        },
        {
          parent: "tbk",
          children: [
            // {
            //   title: "TBK Participations",
            //   link: "/tbk_purchase"
            // },
            // {
            //   title: "TBK Renewal",
            //   link: "/tbk_renewal"
            // },
            {
              title: "TBK Claim",
              link: "/tbk_claim",
              badge: 0
            }
            // {
            //   title: "Live Chat",
            //   link: "/live-chat/2",
            //   badge: 0,
            // },
            //  {
            //   title: "TBK Claim Report",
            //   link: "/report-claims",
            //   badge: 0
            // },
          ]
        },
        {
          parent: "admin",
          children: [
            {
              title: "Manage Users",
              link: "/manage-users"
            },
            {
              title: "Activity Logs",
              link: "/log"
            }
            // {
            //   title: "Change Forms",
            //   link: "/change-forms"
            // },
          ]
        },
        {
          parent: "marketing",
          children: [
            {
              title: "Approved Gifts",
              link: "/marketing/approved-gifts"
            },
            {
              title: "Authorised Workshop",
              link: "/marketing/workshop"
            },
            {
              title: "Campaign Terms and Conditions",
              link: "/campaign"
            },
            {
              title: "FAQ",
              link: "/faq"
            },
            {
              title: "Home Banners",
              link: "/banners"
            },
            {
              title: "Live Webinar",
              link: "/marketing/webinar"
            },
            {
              title: "Mass Notification",
              link: "/marketing/mass-notification",
            },
            {
              title: "My Activity",
              link: "/marketing/my-activity",
            },
            {
              title: "Newsletter",
              link: "/marketing/newsletter"
            },
            {
              title: "Products",
              link: "/marketing",
            },
            {
              title: "Payment Promotion",
              link: "/marketing/payment_promotion"
            },
            {
              title: "Promotion / Advert",
              link: "/promotion",
            },
            {
              title: "Report - Gifts",
              link: "/marketing/gift/report"
            },
            {
              title: "Report - Total Registration",
              link: "/marketing/total-registration"
            },

            {
              title: "Survey",
              link: "/marketing/survey"
            },

            {
              title: "Surveys & Referral",
              link: "/marketing/survey-referral"
            },

            {
              title: "Tier Downgrade",
              link: "/marketing/tier-downgrade",
            },
          ]
        },

        {
          parent: "lps-main",
          children: [
            {
              title: "Affiliate",
              link: "/lps/affiliate"
            },

            {
              title: "Award Points",
              link: "/lps/award-points"
            },

            {
              title: "Cash Winner",
              link: "/lps/cash-winner"
            },

            {
              title: "Charity",
              link: "/lps/charity"
            },

            {
              title: "Charity Points",
              link: "/lps/charity-point"
            },

            {
              title: "Customer Points",
              link: "/lps/user-balance"
            },

            {
              title: "Expired Points",
              link: "/lps/report/expired-points"
            },

            {
              title: "Loyalty Cards",
              link: "/lps/loyalty-cards"
            },

            {
              title: "Loyalty Programme Dashboard",
              link: "/lps/dashboard"
            },

            {
              title: "Report - Affiliate",
              link: "/lps/report/view/affiliate"
            },
            {
              title: "Report - LPS Points Earned",
              link: "/lps/points-earned"
            },
            {
              title: "Report - LPS Points Spent",
              link: "/lps/points-spent"
            },
            {
              title: "Report - Summary",
              link: "/lps/report-summary"
            },
            {
              title: "Report - Vendor",
              link: "/lps/report/view/vendor"
            },
            {
              title: "TBM Points Rate",
              link: "/lps/point"
            },
            {
              title: "Vendor Account",
              link: "/lps/account/vendor"
            },
            {
              title: "Vendor Request",
              link: "/lps/vendor/view"
            },
            {
              title: "Voucher",
              link: "/lps/voucher/product"
            }
          ]
        },

        {
          parent: "report",
          children: [
            {
              title: "Vendor Report",
              link: "/report/view/vendor"
            },
            {
              title: "Expired Points",
              link: "/report/expired-points"
            },
            {
              title: "Affiliate Report",
              link: "/report/view/affiliate"
            }
            // {
            //   title: "Musafir Orders",
            //   link: "/report/musafir/order"
            // }
          ]
        },

        // REDEEM
        {
          parent: "redeem",
          children: [
            {
              title: "Redeem",
              link: "/redeem"
            },
            // {
            //   title: "Refund",
            //   link: "/refund"
            // },
            {
              title: "Redeem Report",
              link: "/redeem/report"
            },
            {
              title: "Used Voucher Report",
              link: "/redeem/voucher/report"
            }
          ]
        },

        // Setting
        // {
        //   parent: "setting",
        //   children: [
        //     {
        //       title: "TBM Points",
        //       link: "/setting/point",
        //     },
        //     {
        //       title: "Charity Points",
        //       link: "/setting/charity-point",
        //     },
        //     {
        //       title: "Surveys & Referral",
        //       link: "/setting/survey-referral",
        //     },
        //   ],
        // },

        {
          parent: "threshold",
          children: [
            {
              title: "Threshold",
              link: "/treshold"
            },
            {
              title: "Auto Logout & Disabled",
              link: "/variables"
            }
          ]
        }

        //  {
        //   parent: "finance",
        //   children: [
        //     {
        //       title: "TBA",
        //       link: "/report-transactions-tba"
        //     },
        //     {
        //       title: "TBK",
        //       link: "/report-transactions-tbk"
        //     },
        //     // {
        //     //   title: "Musafir Orders",
        //     //   link: "/report/musafir/order"
        //     // }
        //   ]
        // },
      ]
    };
  },
  computed: {
    roledLists() {
      return this.lists.filter(list => {
        // semua
        if (list.roles.indexOf("All") > -1) {
          // show semua
          if (list.except.length === 0) {
            return true;
            // show semua but hide exception
            // except berisi
          } else {
            list.except.forEach(exc => {
              this.roles.forEach(role => {
                if (role.name === exc) {
                  return false;
                }
              });
            });
            return true;
          }
          // show defined roles
        } else {
          let show = false;
          list.roles.forEach(lrole => {
            this.roles.forEach(role => {
              if (role.name === lrole) {
                show = true;
              }
            });
          });
          return show;
        }
      });
    },

    // Add this new computed property for filtered sideLists
    filteredSideLists() {
      return this.sideLists.map(sideList => {
        // Check if this is the marketing parent and user has only TBA Staff role
        if (sideList.parent === "marketing") {
          const userRoleNames = this.roles.map(role => role.name);
          const hasTBAStaff = userRoleNames.includes("TBA Staff");
          const hasOtherRoles = userRoleNames.some(roleName =>
            roleName !== "TBA Staff" &&
            ["Administrator", "Marketing"].includes(roleName)
          );

          // If user has TBA Staff but no other marketing-related roles, show only "Products"
          if (hasTBAStaff && !hasOtherRoles) {
            return {
              ...sideList,
              children: sideList.children.filter(child => child.title === "Products")
            };
          }
        }

        // For all other cases, return the original sideList
        return sideList;
      });
    }
  },
  methods: {
    getNotification() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/notifications/unreads/count", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.lists[1].badge = res.data.count;
          });
      }
    },

    async loadTbaNewClaim() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        await axios
          .get("tba/claim/10", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.tbaNew_claim = res.data;

            this.sideLists[0].children[0].badge = this.tbaNew_claim.length;
            // remove this after chat implemented
            this.lists[2].badge = this.tbaNew_claim.length;
          });
      }
    },

    async loadTbkNewClaim() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        await axios
          .get("tbk/claim/10", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.tbkNew_claim = res.data;

            this.sideLists[1].children[0].badge = this.tbkNew_claim.length;
            // remove this after chat implemented
            this.lists[3].badge = this.tbkNew_claim.length;
          });
      }
    },

    // for chat uncomment after implemented

    // async loadTbaNewChat() {
    //   let token = localStorage.getItem("token");

    //   // check if has token
    //   if (token !== null) {
    //     token = JSON.parse(token);
    //     token = token.access_token;

    //     await axios
    //       .get("chat/conversations?tb_type=1", {
    //         headers: {
    //           Authorization: "Bearer " + token
    //         }
    //       })
    //       .then(res => {
    //         this.tbaNew_chat = res.data;

    //         let chat_counts = 0;
    //         this.tbaNew_chat.forEach(item => {
    //           chat_counts += item.notification_count;
    //         });
    //         this.sideLists[0].children[4].badge = chat_counts;
    //         this.lists[2].badge = this.tbaNew_claim.length + chat_counts;
    //       });
    //   }
    // },

    // async loadTbkNewChat() {
    //   let token = localStorage.getItem("token");

    //   // check if has token
    //   if (token !== null) {
    //     token = JSON.parse(token);
    //     token = token.access_token;

    //     await axios
    //       .get("chat/conversations?tb_type=2", {
    //         headers: {
    //           Authorization: "Bearer " + token
    //         }
    //       })
    //       .then(res => {
    //         this.tbkNew_chat = res.data;

    //         let chat_counts = 0;
    //         this.tbkNew_chat.forEach(item => {
    //           chat_counts += item.notification_count;
    //         });
    //         this.sideLists[1].children[1].badge = chat_counts;
    //         this.lists[3].badge = this.tbkNew_claim.length + chat_counts;
    //       });
    //   }
    // },

    loadTbaCallPendings() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/calls/pendings/tba", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.tbaPending_call = res.data;
            this.lists[6].badge = this.tbaPending_call.length;
            if (!this.lists[6].lps) {
              this.tbaPending_call = res.data;
              this.lists[6].badge = this.tbaPending_call.length;
            }
          });
      }
    },

    loadTbkCallPendings() {
      let token = localStorage.getItem("token");

      // check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get("/calls/pendings/tbk", {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            this.tbkPending_call = res.data;
            this.lists[7].badge = this.tbkPending_call.length;
            if (!this.lists[7].lps) {
              this.tbkPending_call = res.data;
              this.lists[7].badge = this.tbkPending_call.length;
            }
          });
      }
    },

    async loadChatNotifications() {
      let token = localStorage.getItem("token");

      if (token === null) {
        return false;
      }

      token = JSON.parse(token);
      token = token.access_token;

      const header = { headers: { Authorization: "Bearer " + token } };

      const url = `/chat/notifications/counts`;
      const { data } = await axios.get(url, header);
      const { counts } = data;

      counts.forEach(count => {
        if (count.tb_type === "1") {
          this.lists[2].notification_badge = count.count;
          this.sideLists[0].children[2].badge = count.count;
        } else if (count.tb_type === "2") {
          this.lists[3].notification_badge = count.count;
          this.sideLists[1].children[1].badge = count.count;
        }
      });
    },

    async loadBadges() {
      setInterval(() => {
        this.getNotification();
        this.loadTbaNewClaim();
        this.loadTbkNewClaim();
        // uncomment after chat implemented
        // this.loadTbaNewChat();
        // this.loadTbkNewChat();
        this.loadTbaCallPendings();
        this.loadTbkCallPendings();
      }, 60 * 1000);
    },

    loadNotificationBadges() {
      setInterval(() => {
        this.loadChatNotifications();
      }, 5 * 1000);
    }
  },

  async mounted() {
    this.getNotification();
    await this.loadTbaNewClaim();
    await this.loadTbkNewClaim();
    // uncomment after chat implemented
    // await this.loadTbaNewChat();
    // await this.loadTbkNewChat();
    this.loadTbaCallPendings();
    this.loadTbkCallPendings();
    // this.loadChatNotifications()
    await this.loadBadges();
    // this.loadNotificationBadges()
    // this.loadTbaNew();
  }
};
</script>

<style>
.active {
  background: #f9f9f9;
}
</style>
